
export default {
  props: {
    editTagList: Array
  },
  data: function data() {
    return {
      searchInput: ''
    };
  },

  computed: {
    list: function list() {
      var _this = this;

      return this.editTagList.filter(function (item) {
        return item.name.indexOf(_this.searchInput) > -1;
      });
    }
  },
  watch: {},
  methods: {
    back: function back() {
      this.$emit('back');
    },
    close: function close() {
      this.$emit('close');
    },
    deleteBtn: function deleteBtn(item) {
      this.$emit('deleteBtn', item);
    },
    editBtn: function editBtn(item) {
      this.$emit('editBtn', item);
    }
  }
};